import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import styled from "styled-components"

const Promos = ({ cartSubtotal, onPromoApplied }) => {
  const [promoInput, setPromoInput] = useState('');
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const { i18n } = useTranslation();

 async function applyPromo() {
  const code = promoInput.toUpperCase();

  // ✅ ONLY ADD THIS BLOCK (DO NOT TOUCH ANYTHING ELSE)
  if (code === "DANSHIPFIX843") {
    onPromoApplied(promoInput, 0, "free_shipping");
    setError('');
    setSuccessMessage("Free shipping applied 🎉");
    return;
  }

  try {
      const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
      const res = await fetch(`${API_URL}checkPromoCode`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: promoInput, lang: i18n.language })
      });
      const data = await res.json();

      if (!data.valid) {
        setError(data.message || 'Invalid promo code');
        setSuccessMessage('');
        console.log(successMessage)
        onPromoApplied(null, 0);
        return;
      }

       // 💅 FREE SHIPPING OVERRIDE (FRONTEND ONLY)
      if (code === "DANSHIPFIX843") {
        onPromoApplied(promoInput, 19.95, "free_shipping");
        setError('');
        setSuccessMessage("Free shipping applied 🎉");
        return;
      }

      const discountAmount = (cartSubtotal * data.discountPercent) / 100;
      onPromoApplied(promoInput, data.discountPercent); // send percent for CartPage
      console.log(discountAmount)
      setError('');
      setSuccessMessage(`Applied ${promoInput} for ${data.discountPercent}% off 🎉`);
    } catch (err) {
      console.error(err);
      setError('Something went wrong.');
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      applyPromo();
    }
  };

  return (
    <div className="promo-code-box">
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <InputBox
        type="text"
        value={promoInput}
        onChange={(e) => setPromoInput(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Enter promo code"
      />
      <ApplyButton onClick={applyPromo}>Apply</ApplyButton>
    </div>
  );
};

export default Promos;

const InputBox = styled.input`
  padding: 3px;
  border-radius: 5px;
  border: black 0.1px solid;
`
const ApplyButton = styled.button`
margin-left: 5px;
padding: 5px;
border-radius: 5px;
border: none;
cursor: pointer;
background-color:rgb(138, 163, 134);
color: white;
`